import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../components/PageHeader';
import { WebhooksPanel } from './WebhooksPanel';

/**
 * Die Webhooks als eigene Seite -- F3-18.
 *
 * Sie waren ein Reiter der Automatisierung. Ein Webhook ist aber keine Regel,
 * sondern eine Schnittstelle: Er meldet **von hier** an einen fremden Dienst.
 * Er steht deshalb neben den API-Token (eine Maschine meldet sich **hier**
 * an) und den Fremddiensten (dieses System meldet sich **dort** an).
 */
export function WebhooksPage() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('webhooks.title')} subtitle={t('webhooks.subtitle')} />
      <WebhooksPanel />
    </>
  );
}
